import React from "react";
import styles from "./Styles.module.css";
import eye from "../../Images/eye.svg";
import good from "../../Images/good.png";

const AlertModal = ({ info, setAlertDescription, count = null }) => {
  return (
    <>
      {info === "Даем подсказку!" ? (
        <section className={styles.hintModal}>
          <div
            onClick={() => setAlertDescription("")}
            className={styles.clouse}
          >
            ✕
          </div>
          <div className={styles.hint}>
            <img style={{ width: "80px" }} src={eye} alt="" />
          </div>
          <p>{info}</p>
        </section>
      ) : info === "Обследования назначены верно!" ||
        info === "Диагноз верный!" ||
        info === "Факторы определены верно!" ||
        info === "Лечение верное!" ||
        info == "Ответ верный!" ? (
        <section className={styles.itsRightModal}>
          <div
            onClick={() => setAlertDescription("")}
            className={styles.clouse}
          >
            ✕
          </div>
          <div className={styles.itsRight}>
            <img style={{ width: "80px" }} src={good} alt="" />
          </div>
          <p>{info}</p>
        </section>
      ) : (
        <section className={styles.alertModal}>
          <div
            onClick={() => setAlertDescription("")}
            className={styles.clouse}
          >
            ✕
          </div>
          <div className={styles.attantion}>!</div>
          <p>{info}</p>
          {count != null ? (
            <>
              {window.location.hash == "#/future-treatment" ? (
                <p>{count < 2 ? `Осталось попыток: ${2 - count}` : null}</p>
              ) : (
                <p>{count < 3 ? `Осталось попыток: ${3 - count}` : null}</p>
              )}
            </>
          ) : null}
        </section>
      )}
    </>
  );
};

export default AlertModal;
